<template>
  <gg-card>
    <gg-card-text class="pa-3">
      <!-- Add-ons have no backend yet. The previous version showed a hardcoded mock
           catalog with fake prices and an "Add" that only flipped local state and
           toasted success — removed in favour of an honest, accessible empty state. -->
      <div class="kvm-coming text-center py-10">
        <v-icon size="56" color="primary" class="mb-3" aria-hidden="true">mdi-puzzle</v-icon>
        <h2 class="kvm-coming__heading mb-2">Add-ons &mdash; coming soon</h2>
        <p class="kvm-coming__text mb-0 mx-auto">
          Server add-ons aren't available to purchase yet. We're working on bringing them to your dashboard.
        </p>
      </div>
    </gg-card-text>
  </gg-card>
</template>

<script>
export default {
  name: 'HostingKvmAddons',
  props: {
    // Provided by KvmServiceView via <router-view :server :loading>; kept to
    // preserve the component contract even though the body is now a static state.
    server: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
}
</script>

<style scoped lang="scss">
@import './kvm-ui';

.kvm-coming__heading {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.4;
}

.kvm-coming__text {
  @include kvm-secondary-text;
  max-width: 28rem;
}
</style>
